import { useMutation, useQueryClient } from 'react-query';
import { authFetch } from '../../CommonUtils/authFetch';
import { urlWithParams } from '../../CommonUtils/urlWithParams';
import { WorkflowData, WorkflowIdEnum } from './useWorkflowDataQuery';
import { queryKeys } from './queryKeys';

export enum WorkflowDirection {
  Next = 'Next',
  Previous = 'Back',
}

export const WORKFLOW_NEXT_MK = 'workflowNext';

interface WorkflowDirectionParams {
  clientId: string;
  stepId: string;
  workflowId: WorkflowIdEnum;
}

export const fetchWorkflowDirection = (direction: WorkflowDirection) => async ({
  clientId,
  stepId,
  workflowId,
}: WorkflowDirectionParams): Promise<WorkflowData> => {
  return authFetch(
    urlWithParams(`/Consumer/Workflow/${direction}`, {
      ClientId: clientId,
      StepId: stepId,
      WorkflowId: workflowId,
    }),
  );
};

interface MutationParams {
  clientId: string;
}

export const useWorkflowNextMutation = ({ clientId }: MutationParams) => {
  const queryClient = useQueryClient();

  return useMutation(fetchWorkflowDirection(WorkflowDirection.Next), {
    mutationKey: WORKFLOW_NEXT_MK,

    onSuccess(data) {
      queryClient.setQueryData(queryKeys.workflowData(clientId, data.Route.Params.pageId), data);
    },
  });
};
